/* eslint-disable import/prefer-default-export */
import { atomWithHash } from 'jotai/utils';

export const contentPreview = atomWithHash('preview', '');
